import { serviceModel } from './service';
import { listings } from '../lib/api/services';
import Listing from '../interfaces/Listing';

export default serviceModel<Listing>(listings);
